import { getDebtorFieldKey } from "integrations/dromo/debtorSchemaFields";

export { convertToDromoCustomField as convertToDebtorAssetDromoCustomField } from "integrations/dromo/dromoUtils";

export function getDebtorAssetFieldKey(fieldName, debtorNumber, assetNumber) {
  const assetFieldName = `debtor_asset_${assetNumber}_${fieldName}`;
  return getDebtorFieldKey(assetFieldName, debtorNumber);
}

// Remove required validators from custom fields since Dromo doesn't support
// conditional required validation based on category values.
// The backend will validate required fields based on the selected category.
function removeRequiredValidators(cf) {
  const validators = cf.validators?.filter((v) => v.validate !== "required") || [];
  return validators.length > 0 ? validators : undefined;
}

export function getDebtorAssetFields(
  debtorNumber,
  assetsPerDebtor,
  categoryOptions,
  customFieldsSchema,
) {
  const fields = [];

  for (let assetNum = 1; assetNum <= assetsPerDebtor; assetNum++) {
    const labelPrefix = `[Debtor ${debtorNumber}] [Asset ${assetNum}]`;
    const categoryFieldKey = getDebtorAssetFieldKey("category", debtorNumber, assetNum);

    fields.push({
      key: categoryFieldKey,
      label: `${labelPrefix} Category`,
      type: "select",
      selectOptions: [{ label: "", value: "" }, ...categoryOptions],
    });

    fields.push({
      key: getDebtorAssetFieldKey("name", debtorNumber, assetNum),
      label: `${labelPrefix} Name`,
      type: "string",
      validators: [
        {
          validate: "require_with",
          fields: [categoryFieldKey],
        },
      ],
    });

    fields.push({
      key: getDebtorAssetFieldKey("value", debtorNumber, assetNum),
      label: `${labelPrefix} Value`,
      type: "number",
    });

    customFieldsSchema.forEach((cf) => {
      fields.push({
        ...cf,
        key: getDebtorAssetFieldKey(cf.key, debtorNumber, assetNum),
        label: `${labelPrefix} ${cf.label}`,
        validators: removeRequiredValidators(cf),
      });
    });
  }

  return fields;
}

export function getDebtorAssetSchemaFields(
  numberOfDebtors,
  assetsPerDebtor,
  categoryOptions,
  customFieldsSchema,
) {
  const fields = [];

  for (let debtorNum = 1; debtorNum <= numberOfDebtors; debtorNum++) {
    fields.push(
      ...getDebtorAssetFields(debtorNum, assetsPerDebtor, categoryOptions, customFieldsSchema),
    );
  }

  return fields;
}
